var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-menu",
    {
      staticClass: "el-menu-vertical-president",
      attrs: { "active-text-color": "#ffd04b" }
    },
    [
      _c(
        "el-submenu",
        { attrs: { index: "1" } },
        [
          _c("template", { slot: "title" }, [
            _c("i", { staticClass: "el-icon-location" }),
            _vm._v(" "),
            _c("span", [_vm._v("Ροές Εργασιών Από")])
          ]),
          _vm._v(" "),
          _vm._l(this.roles, function(role) {
            return _c(
              "el-menu-item",
              {
                key: role.id,
                attrs: { index: _vm.roleIndexId(role.id) },
                on: {
                  click: function($event) {
                    _vm.showApplicationsFrom(role.id)
                  }
                }
              },
              [
                _vm._v(_vm._s(role.name) + " "),
                _c("el-badge", { attrs: { value: role.badge } })
              ],
              1
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-menu-item",
        { attrs: { index: "1000" }, on: { click: _vm.toggleSearch } },
        [
          _c("template", { slot: "title" }, [
            _c("span", [_vm._v("Αναζήτηση Αιτήσεων")])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-menu-item",
        { attrs: { index: "1001" }, on: { click: _vm.toggleUniSearch } },
        [
          _c("template", { slot: "title" }, [
            _c("span", [_vm._v("Αναζήτηση Ιδρυμάτων")])
          ])
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-menu-item",
        { attrs: { index: "1002" }, on: { click: _vm.toggleConsultantsList } },
        [
          _c("template", { slot: "title" }, [
            _c("span", [_vm._v("Λίστα αξιολογητών")])
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e3805f0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3805f0a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/roleSpecific/PresidentMenu.vue
// module id = null
// module chunks = 